import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { useSnackBars } from "../../contexts/Snackbar/SnackbarContext";
import { PersonService } from "../../services/PersonService";

export function useAllPersons() {
  const { showErrorSnackbar } = useSnackBars();

  const { data, isLoading } = useQuery(
    [namesUseQuery?.ALL_PERSONS],
    () => PersonService.getAll(),
    {
      refetchOnWindowFocus: false,
      onError: (error) => {
        console.log(error);
        showErrorSnackbar(error?.response?.data?.body);
      },
    }
  );

  return {
    data: data,
    isLoading,
  };
}
